var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 421,
    viewBox: "0 0 854 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M733.02 177.729C722.429 98.9311 616.15 48.9055 536.304 49.9117C444.291 51.0811 409.611 119.749 339.588 98.8632C275.688 79.8265 271.923 12.8718 224.946 2.32005C181.772 -7.37506 113.456 33.1051 0.871826 233.48",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2395 242.359C117.456 44.8806 185.811 2.83678 229.597 10.737C262.048 16.6384 274.555 49.1503 299.946 74.5642C312.619 87.6463 328.206 97.2387 345.308 102.48C401.326 119.695 434.716 81.5942 494.577 65.2499C509.835 61.0357 525.515 58.7081 541.294 58.3151C621.466 56.0443 726.559 99.4071 738.792 175.336",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6198 251.211C121.468 56.6425 189.824 13.0486 234.13 19.1675C266.699 23.6683 279.948 54.6301 305.391 78.7523C318.367 91.3638 333.931 100.716 350.896 106.097C406.107 123.597 439.484 89.2768 499.554 73.694C514.819 69.7003 530.44 67.3672 546.166 66.732C626.677 63.455 730.571 99.883 744.446 172.943",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9838 260.036C125.438 68.4181 193.833 23.2876 238.713 27.5844C271.425 30.7119 285.364 60.0963 310.898 82.9403C324.15 95.0739 339.679 104.192 356.495 109.714C410.95 127.5 444.196 96.9459 504.54 82.1381C519.82 78.3291 535.4 75.9761 551.087 75.1081C631.923 70.6753 734.619 100.318 750.135 170.509",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.355 268.929C129.441 80.18 197.823 33.5402 243.315 36.0149C276.132 37.7826 290.827 65.5898 316.439 87.1148C329.976 98.7766 345.498 107.671 362.192 113.331C415.891 131.402 449.046 104.629 509.69 90.5822C524.953 86.9956 540.458 84.6408 556.068 83.5386C637.242 77.95 738.74 100.821 755.91 168.143",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6704 277.794C133.428 91.9419 201.849 42.4737 247.914 44.4318C280.796 45.7916 296.285 70.988 321.95 91.3028C335.765 102.472 351.28 111.141 367.846 116.948C420.79 135.305 453.828 112.311 514.679 99.0399C529.938 95.6397 545.39 93.2688 560.94 91.9419C642.454 85.1431 742.753 101.283 761.564 165.75",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1045 286.66C137.429 103.718 205.798 54.1407 252.501 52.7809C285.487 51.9922 301.772 76.468 327.475 95.5046C341.554 106.177 357.062 114.626 373.501 120.579C425.69 139.221 458.649 119.994 519.722 107.498C534.977 104.3 550.378 101.922 565.866 100.373C647.718 92.418 746.819 101.732 767.272 163.37",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4686 295.526C141.386 115.48 209.768 64.366 257.097 61.2794C290.161 59.0766 307.279 81.8254 332.995 99.6791C347.326 109.845 362.835 118.07 379.152 124.155C430.572 143.096 463.453 127.663 524.761 115.901C539.026 113.182 554.255 110.571 570.787 108.735C652.991 99.5839 750.88 102.222 772.975 160.964",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8326 304.391C145.408 127.255 213.738 74.741 261.679 69.6691C294.834 66.1745 312.799 87.1964 338.542 103.84C353.124 113.494 368.644 121.511 384.842 127.758C435.506 146.985 468.283 135.305 529.839 124.345C544.169 121.789 559.359 119.205 575.761 117.138C658.199 106.804 754.942 102.698 778.678 158.557",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2164 313.243C149.411 139.017 217.715 85.0888 266.281 78.1268C299.515 73.354 318.392 92.5947 344.03 108.042C358.845 117.178 374.372 124.992 390.447 131.402C440.369 150.915 473.055 143.015 534.844 132.762C549.175 130.369 564.378 127.785 580.649 125.501C663.518 113.916 759.01 103.092 784.387 156.096",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5823 322.109C153.396 150.779 221.687 95.4638 270.84 86.5437C304.151 80.5064 323.888 97.9385 349.526 112.243C364.571 120.842 380.117 128.449 396.073 135.019C445.226 154.817 477.821 150.684 539.859 141.274C554.254 139.071 569.418 136.474 585.546 133.986C668.753 121.15 763.033 103.636 790.079 153.77",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9517 330.975C157.398 162.554 225.688 105.839 275.466 94.9607C308.869 87.6724 329.479 103.269 355.065 116.431C369.773 123.992 384.833 131.62 401.756 138.636C450.153 158.706 482.657 158.366 544.928 149.718C559.363 147.692 574.501 145.082 590.525 142.389C674.07 128.302 767.152 104.098 795.826 151.377",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3175 339.84C161.396 174.371 229.595 116.241 280.051 103.391C313.544 94.8382 335.066 108.572 360.587 120.619C375.647 127.731 390.746 135.142 407.408 142.253C455.05 162.65 487.449 166.035 549.968 158.162C564.442 156.327 579.567 153.702 595.422 150.792C679.293 135.427 771.189 104.561 801.504 148.984",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6617 348.706C165.385 186.092 233.649 126.657 284.639 111.822C318.224 102.045 340.658 113.861 366.114 124.821C381.538 131.457 396.663 138.663 413.013 145.884C459.912 166.525 492.194 173.732 555.013 166.634C569.539 164.961 584.625 162.323 600.349 159.223C684.559 142.552 775.257 105.023 807.213 146.591",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0671 357.558C169.383 197.854 237.609 137.1 289.237 120.239C322.926 109.225 346.259 119.11 371.623 128.996C387.413 135.142 402.59 142.172 418.718 149.487C464.835 170.414 497.052 181.387 560.054 175.064C575.244 173.374 590.341 170.873 605.285 167.572C689.808 149.664 779.359 105.512 812.918 144.184",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.433 366.423C173.381 209.629 241.672 147.502 293.782 128.655C327.575 116.418 351.82 124.345 377.158 133.183C393.312 138.826 408.516 145.68 424.37 153.104C469.745 174.316 501.858 189.07 565.068 183.508C580.244 182.024 595.314 179.521 610.182 176.016C695.057 156.694 783.383 105.975 818.636 141.736",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8024 375.289C177.37 221.391 245.738 157.999 298.422 137.072C332.294 123.638 357.463 129.553 382.671 137.358C399.19 142.484 414.419 149.202 430.013 156.721C474.62 178.219 506.654 196.739 570.138 191.952C585.3 190.656 600.344 188.138 615.135 184.419C700.296 163.819 787.45 106.451 824.344 139.398",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.179 384.155C181.366 233.221 249.695 168.456 303.004 145.503C337.019 130.845 363.061 134.734 388.178 141.546C405.114 146.128 420.33 152.71 435.663 160.338C479.514 182.094 511.445 204.421 575.175 200.41C590.323 199.294 605.343 196.759 620.055 192.836C705.529 170.89 791.511 106.913 830.046 137.004",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5485 393.02C185.302 244.929 253.736 178.94 307.605 153.974C341.737 138.119 368.652 139.955 393.704 145.816C410.965 149.895 426.273 156.313 441.319 164.037C484.415 186.105 516.254 212.186 580.219 208.909C595.35 207.972 610.349 205.42 624.982 201.294C710.768 177.988 795.643 107.47 835.754 134.666",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.918 401.886C189.356 256.704 257.789 189.423 312.192 162.35C346.468 145.285 374.243 145.041 399.229 149.922C416.856 153.376 432.176 159.753 446.975 167.599C489.302 189.954 521.05 219.8 585.263 217.326C600.377 216.576 615.358 214.007 629.908 209.67C715.994 184.963 799.644 107.851 841.463 132.218",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.296 410.738C193.353 268.466 261.839 199.975 316.737 170.767C351.143 152.519 379.764 150.167 404.686 154.11C422.677 156.952 438.036 163.261 452.562 171.175C494.146 193.829 525.803 227.456 590.25 225.743C605.351 225.165 620.319 222.579 634.792 218.046C721.112 191.83 803.655 108.327 847.141 129.811",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.65 419.604C249.449 193.407 345.436 150.412 410.261 158.298C481.026 166.906 508.033 235.451 595.343 234.2C697.766 232.718 800.123 105.635 852.872 127.418",
    stroke: "#F06501",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bgLogin.60d14ca38a9a15c3cab6b9984745d755.svg";
export { ForwardRef as ReactComponent };